import styled from 'styled-components';

import { OFFSET } from '@theme/helpers';
import { media } from '@theme/media';

export const List = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 ${OFFSET.S};
  justify-content: center;
  margin: 0;
  gap: ${OFFSET.S};

  ${media.tablet} {
    padding: 0 ${OFFSET.M};
  }
`;

export const Item = styled.li`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
